import React, { Component } from 'react';
import './App.css';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import twitterLogo from './assets/twitter-logo.svg';
import redditLogo from './assets/reddit-logo.svg';
import mediumLogo from './assets/medium-logo.svg';
import telegramLogo from './assets/telegram-logo.svg';
import Countdown from "react-countdown";
import youtubeLogo from "./assets/youtube-logo.svg";
import substackLogo from "./assets/substack-logo.png";
import discordLogo from "./assets/discord-logo.svg";
import linkedinLogo from "./assets/linkedin-logo.svg";
import AustinGreen from './assets/Austin-Green.jpeg'
import CianteraRose from './assets/Ciantera-Rose.jpeg'
import CoreyCaplan from './assets/Corey-Caplan.png'
import AdamKnuckey from './assets/Adam-Knuckey.png'

const CustomForm = ({ status, message, onValidated }) => {
  let email;
  const submit = () =>
    email &&
    email.value.indexOf("@") > -1 &&
    onValidated({
      EMAIL: email.value,
      FNAME: '',
      LNAME: ''
    });

  return (
    <div className={'email-signup-input-wrapper'}>
      <input className={'email-signup-input'} ref={node => (email = node)} type={'email'} placeholder={'Email'} />
      <button className={`email-signup-submit-button ${status === "sending" && 'sending'} ${status === "success" && 'submitted'}`} onClick={() => submit()} disabled={status === "sending"}>
        { status === "sending" ? <span>Submitting...</span> : status === "success" ? <span>Submitted!</span> : <span>Join</span> }
      </button>
      <div className={`confirm-email-text ${status === "success" && 'show'}`}>
        Please click the link in the confirmation email we've sent you
      </div>
    </div>
  );
};

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hideLearnMore: false,
      showComingSoon: false
    }
  }

  handleScroll() {
    const body = document.body;
    if (window.pageYOffset > 25) {
      this.setState({ hideLearnMore: true });
    }
    else {
      this.setState({ hideLearnMore: false });
    }
  }

  componentDidMount() {
    window.addEventListener("scroll", () => this.handleScroll());
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", () => this.handleScroll());
  }

  handleClickDEX() {
    window.location.href = 'https://app.fatexfi.io';
    // this.setState({ showComingSoon: true });
    // setTimeout(() => {
    //   this.setState({ showComingSoon: false });
    // }, 5000);
  }

  render() {

    const mailChimpUrl = process.env.REACT_APP_MAILCHIMP_URL;

    return (
      <div className="App">
        <div className={'top-bar'}>
          <a href={'https://www.twitter.com/FATExDAO'} target={'_blank'}><img src={twitterLogo} alt={'twitter logo'} /></a>
          <a href={'https://www.reddit.com/r/FATEx'} target={'_blank'}><img src={redditLogo} alt={'reddit logo'} /></a>
          <a href={'https://fatexdao.medium.com'} target={'_blank'}><img src={mediumLogo} alt={'medium logo'} /></a>
          <a href={'https://t.me/FATExDAO'} target={'_blank'}><img src={telegramLogo} alt={'telegram logo'} /></a>
          <a href={'https://discord.gg/uA6xrmsRfu'} target={'_blank'}><img src={discordLogo} alt={'discord logo'} /></a>
          <a href={'https://fatex.substack.com/'} target={'_blank'}><img style={{ filter: 'brightness(100)' }} src={substackLogo} alt={'substack logo'} /></a>
          <a href={'https://youtube.com/channel/UCvD3ItDf063xc_I4412wXCg'} target={'_blank'}><img src={youtubeLogo} alt={'youtube logo'} /></a>
          <a href={'https://www.linkedin.com/company/fatexdao'} target={'_blank'}><img src={linkedinLogo} alt={'linkedin logo'} /></a>
        </div>
        <div className={'top-section'}>
          <div className={'titleWrapper'}>
            <div className={'title'}>
              FATEx<span className={'tiny'}>DAO</span>
            </div>
            <div className={'subtitle'}>
              FIDUCIARY - ASSETS - TRADE - ENTERPRISE
            </div>
            <div className={'buttons-wrapper'}>
              <div><div className={'button dex-button'} onClick={() => this.handleClickDEX()}>
                LAUNCH APP{Date.now() < 1630023498000 && ` - Testnet`}
                <div className={`coming-soon ${this.state.showComingSoon && 'show-coming-soon'}`}>
                  Coming soon
                </div>
                {Date.now() < 1630023498000 && <div className={'countdown-timer'}>
                  Mainnet in <Countdown date={1630023498000} />
                </div>}
              </div>
              </div>
              <div className={Date.now() < 1630023498000 && 'spacer'}>
                <a href={'https://fatexdao.gitbook.io/fatexdao'} target={'_blank'}>
                  <div className={'button whitepaper-button'}>
                    GREENPAPER
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className={`learn-more-wrapper ${this.state.hideLearnMore && 'hide'}`}>
            <div className={'learn-more-text'}>
              LEARN MORE
            </div>
            <div className={'learn-more-icon'}>
              <ArrowBackIosIcon />
            </div>
          </div>
        </div>
        <div className={'info-section'}>
          <div className={'info-inner'}>
            <div className={'info-subsection'}>
              <div className={'subsection-title'}>
                Disrupt Bigger<br />Disrupt Better<br />Disrupt Forever
              </div>
              <div className={'subsection-content'}>
                FATExDAO is an ESG aligned Neo-DeFi disruptor and economic equalizer<br className={'aligner'} /><span className={'span-aligner'}> </span> oriented on stability, transparency, and fiduciary professionalism.<br className={'aligner'} /><span className={'span-aligner'}> </span>
                FATExDEX mainnet launches on the Harmony blockchain as a traditional<br className={'aligner'} /><span className={'span-aligner'}> </span>liquidity pool emitter of the FATE governance token and to build membership.<br className={'aligner'} /><span className={'span-aligner'}> </span>
                To focus on rapidly evolving into a high-yield, digital depository supported by<br className={'aligner'} /><span className={'span-aligner'}> </span>monetization channels that shift away from crypto-centric emission schemes.
              </div>
            </div>
            <div className={'separator'} />
            <div className={'info-subsection'}>
              <div className={'subsection-title'}>
                Create Value<br />Build Advantages<br />Efficiently Diversify
              </div>
              <div className={'subsection-content'}>
                DLT-tokenization correctly deployed will revamp all financial systems<br className={'aligner'} /><span className={'span-aligner'}> </span>and provide exponential, sustainable wealth.<br className={'aligner'} /><span className={'span-aligner'}> </span>
                With civic leadership we will realign economies to focus on win-only,<br className={'aligner'} /><span className={'span-aligner'}> </span>multi-generational strategies.<br className={'aligner'} /><span className={'span-aligner'}> </span>
                <br />
                Empowering everyone to control their own FATE.
              </div>
            </div>
            <div className={'separator'} />
          </div>
          {/*<div className={'embedded-socials'}>
            <iframe width="560" height="315"
  src="https://www.youtube.com/embed/videoseries?list=PLtAQgLsoJyloJpZTU7WdsfRg9TE-Oy_Iz"
  title="YouTube video player" frameBorder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowFullScreen/>
            <a className="twitter-timeline" data-width="500" data-height="320" data-dnt="true" data-theme="dark"
  href="https://twitter.com/FATExDAO?ref_src=twsrc%5Etfw"/>

          </div>*/}
          <div className={'team-section'}>
            <div className={'team-title'}>
              Founding Team
            </div>
            <div className={'team-members'}>
              <div className={'team-member'}>
                <div className={'team-member-left'}>
                  <div className={'team-member-image'}>
                    <img src={AustinGreen} />
                  </div>
                </div>
                <div className={'team-member-right'}>
                  <span className={'team-member-name'}>
                    Austin Green
                  </span>
                  <span> - </span>
                  <span className={'team-member-role'}>
                    Creator, CEO
                  </span>
                  <div className={'team-member-description'}>
                    B.A. Int'l Political-Economy from Columbia University, M.A. Finance and M.A. Education from NYU.
                    <div className={'line-break'} />
                    10 years in prop/algo trading, corporate/investment banking, and global treasury. Left finance to teach math at a public school in South Bronx, NYC for 5+ years until beginning work on the mission of FATExDAO in 2020.
                  </div>
                </div>
              </div>
              <div className={'team-member'}>
                <div className={'team-member-left'}>
                  <div className={'team-member-image'}>
                    <img src={CianteraRose} />
                  </div>
                </div>
                <div className={'team-member-right'}>
                  <span className={'team-member-name'}>
                    Ciantera Rose
                  </span>
                  <span> - </span>
                  <span className={'team-member-role'}>
                    Associate Founder
                  </span>
                  <div className={'team-member-description'}>
                    B.S. in Biology from Loyola-Marymount University, recent coding bootcamp graduate.
                    <div className={'line-break'} />
                    Extremely passionate about FATExDAO and its potential to increase equity, ESG practice, and removal of social barriers via a highly-profitable and socially responsible corporate enterprise.
                  </div>
                </div>
              </div>
              <div className={'team-member'}>
                <div className={'team-member-left'}>
                  <div className={'team-member-image'}>
                    <img src={CoreyCaplan} />
                  </div>
                </div>
                <div className={'team-member-right'}>
                  <span className={'team-member-name'}>
                    Corey Caplan
                  </span>
                  <span> - </span>
                  <span className={'team-member-role'}>
                    Advisor (Smart Contracts)
                  </span>
                  <div className={'team-member-description'}>
                    B.S. in Computer Science & Business from Lehigh University
                    <div className={'line-break'} />
                    Founded Dolomite.io in 2018 and has been building in the industry ever since. Has extensive in-depth experience developing Ethereum smart contracts and web3-based applications. Built the initial FATEx ecosystem smart contracts, and acts as an advisor to the project.
                  </div>
                </div>
              </div>
              <div className={'team-member'}>
                <div className={'team-member-left'}>
                  <div className={'team-member-image'}>
                    <img src={AdamKnuckey} />
                  </div>
                </div>
                <div className={'team-member-right'}>
                  <span className={'team-member-name'}>
                    Adam Knuckey
                  </span>
                  <span> - </span>
                  <span className={'team-member-role'}>
                    Advisor (Frontend)
                  </span>
                  <div className={'team-member-description'}>
                    B.S. in Computer Science & Business from Lehigh University
                    <div className={'line-break'} />
                    Founded Dolomite.io in 2018 and has been building in the industry ever since. Is passionate about building sleek and easy-to-use web3 user applications in the DeFi space. Designed and built the initial FATEx ecosystem websites and webapps, and acts as an advisor to the project.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={'email-signup'}>
            <div className={'email-signup-title'}>
              Want to help change the world?
            </div>
            <div className={'email-signup-title'}>
              Join us. <br className={'signup-line-break'} />There is work to be done.
            </div>
            {/*<div className={'big-social-links'}>
              <a href={'https://www.twitter.com/FATExDAO'} target={'_blank'}><img src={twitterLogo} alt={'twitter logo'} /></a>
              <a href={'https://www.reddit.com/r/FATEx'} target={'_blank'}><img src={redditLogo} alt={'reddit logo'} /></a>
              <a href={'https://fatexdao.medium.com'} target={'_blank'}><img src={mediumLogo} alt={'medium logo'} /></a>
              <a href={'https://t.me/FATExDAO'} target={'_blank'}><img src={telegramLogo} alt={'telegram logo'} /></a>
              <a href={'https://youtube.com/channel/UCvD3ItDf063xc_I4412wXCg'} target={'_blank'}><img src={youtubeLogo} alt={'youtube logo'} /></a>
              <a href={'https://www.linkedin.com/company/fatexdao'} target={'_blank'}><img src={linkedinLogo} alt={'linkedin logo'} /></a>
            </div>*/}
            <div className={'governance-forum-outer'}>
              <a href={'https://linktr.ee/fatexdao'} target={'_blank'}>
                <div className={'button'}>
                  {/*<img src={discourseLogo} alt={'discourse logo'} /> Join the DAO Governance Forum*/}
                  DAO LINKS
                </div>
              </a>
            </div>
          </div>
          <div className={'hiring-wrapper'}>
            Want to help change the world? Join our team - <a href = "mailto: jobs@fatexdao.io">jobs@fatexdao.io</a>
          </div>
          <div className={'contact-us'}>
            Contact us: <a href = "mailto: info@fatex.io">info@fatex.io</a>
          </div>
          <div className={'mobile-copyright'}>
            © FATExDAO (dba), LLC 2021
            <br/>
            <div>All logos & images are © copyright protected and unregistered trademarks of FATExDAO and its legal entities. Any unauthorized use is expressly
              prohibited.
            </div>
          </div>
          <div className={'footer'}>
            <div className={'footer-left'}>
              FATEx
            </div>
            <div className={'footer-center'}>
              © FATExDAO (dba), LLC 2021
              <br/>
              <div>All logos & images are © copyright protected and unregistered trademarks of <br class={'footer-break'} />FATExDAO and its legal entities. Any unauthorized use is expressly prohibited.</div>
            </div>
            <div className={'footer-right'}>
              <a href={'https://www.twitter.com/FATExDAO'} target={'_blank'}><img src={twitterLogo} alt={'twitter logo'} /></a>
              <a href={'https://www.reddit.com/r/FATEx'} target={'_blank'}><img src={redditLogo} alt={'reddit logo'} /></a>
              <a href={'https://fatexdao.medium.com'} target={'_blank'}><img src={mediumLogo} alt={'medium logo'} /></a>
              <a href={'https://t.me/FATExDAO'} target={'_blank'}><img src={telegramLogo} alt={'telegram logo'} /></a>
              <a href={'https://discord.gg/uA6xrmsRfu'} target={'_blank'}><img src={discordLogo} alt={'discord logo'} /></a>
              <a href={'https://fatex.substack.com/'} target={'_blank'}><img style={{ filter: 'brightness(100)' }} src={substackLogo} alt={'substack logo'} /></a>
              <a href={'https://youtube.com/channel/UCvD3ItDf063xc_I4412wXCg'} target={'_blank'}><img src={youtubeLogo} alt={'youtube logo'} /></a>
              <a href={'https://www.linkedin.com/company/fatexdao'} target={'_blank'}><img src={linkedinLogo} alt={'linkedin logo'} /></a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js